import type { BffLogicalDeviceListResponseApi } from '../../domain/models/logicalDeviceList.model';
import type { DashboardRowDataType } from '../../model/merchant.model';

export function countDisabledDevices(devicesData: BffLogicalDeviceListResponseApi | null | undefined): number {
  const disabledDevices = devicesData ? devicesData?.logicalDevices?.filter((device) => !device?.isEnabled) : [];
  return disabledDevices?.length;
}

export function getDeviceData(
  devicesData: BffLogicalDeviceListResponseApi | null | undefined,
  isDevicesError: boolean,
  hasPermission: boolean,
  deviceFilterField?: DashboardRowDataType['deviceFilterField'],
  deviceFilterValue?: DashboardRowDataType['deviceFilterValue'],
): DashboardRowDataType {
  const numberOfInactiveEntities = countDisabledDevices(devicesData);

  return {
    entity: 'devices',
    numberOfEntities: devicesData?.logicalDevices.length,
    iconName: 'devices',
    ...(deviceFilterField ? { deviceFilterField } : {}),
    ...(deviceFilterValue ? { deviceFilterValue } : {}),
    numberOfInactiveEntities,
    shouldShowViewButton: !!devicesData?.logicalDevices?.length,
    isError: isDevicesError,
    hasPermission,
  };
}
